var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.872 8.297a.833.833 0 010 1.406l-10.85 6.904a.833.833 0 01-1.28-.703V2.096a.833.833 0 011.28-.704l10.85 6.905z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuODcyMyA4LjI5Njg5QzE0LjM4NjkgOC42MjQzNSAxNC4zODY5IDkuMzc1NTMgMTMuODcyMyA5LjcwM0wzLjAyMjQ5IDE2LjYwNzRDMi40Njc3MiAxNi45NjA1IDEuNzQxNzYgMTYuNTYyIDEuNzQxNzYgMTUuOTA0NEwxLjc0MTc2IDIuMDk1NTFDMS43NDE3NiAxLjQzNzkzIDIuNDY3NzIgMS4wMzk0MiAzLjAyMjQ5IDEuMzkyNDZMMTMuODcyMyA4LjI5Njg5WiIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";
export { SvgPlay as ReactComponent };